module.exports = __webpack_public_path__ + "static/media/Seam_5043.e31356d9.jpg";